import React, {Component} from 'react';
import UploadedFile from "./UploadedFile";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import FileUploader from "../../../shared/forms/FIleUploader";
import {ApiDelete, ApiGet, ApiPost} from "../../../shared/services/api-service";
import './TrainingPhaseUploads.scss'
import {formatDate} from "../../../shared/services/utils/utils";

class TrainingPhaseUploads extends Component {
  constructor(props) {
    super(props);

    this.state = {
      uploadedDocuments: [],
      reportsAttachments: []
    }
  }

  componentDidMount() {
    this.getUploadedDocuments()
  }

  getUploadedDocuments() {
    ApiGet(`/api/v1/training-phases/${this.props.trainingPhaseGuid}/files`)
      .then(uploadedDocuments => {
        this.setState({
          uploadedDocuments
        })
      })

    ApiGet(`/api/v1/training-phases/${this.props.trainingPhaseGuid}/report-attachments`)
      .then(reportsAttachments => {
        this.setState({
          reportsAttachments
        })
      })
  }

  uploadDocument(file) {
    ApiPost(`/api/v1/training-phases/${this.props.trainingPhaseGuid}/files`, {
      training_phase_file: {
        file: {
          name: file.s3Key
        },
        date: new Date
      }
    }).then(uploadedFile => {
      this.setState({
        uploadedDocuments: [...this.state.uploadedDocuments, uploadedFile]
      })
    })
  }

  deleteUploadedFile(deletedFile) {
    ApiDelete(`/api/v1/training-phases/files/${deletedFile.id}`)
      .then(() => {
        this.setState({
          uploadedDocuments: this.state.uploadedDocuments.filter(file => file.id !== deletedFile.id)
        })
      })
  }

  render() {
    return (
      <div className="training-phase-uploads">
        {this.state.uploadedDocuments.map(document => (
          <UploadedFile
            key={document.id}
            file={{...document, date: formatDate(document.date)}}
            canDelete={this.props.userContext.hasScope(['ftoc', 'sup', 'cstaff', 'chief'])}
            onDelete={file => this.deleteUploadedFile(file)}/>
        ))}
        {this.state.reportsAttachments.map(document => (
          <UploadedFile
            key={document.guid}
            file={{file: {name: document.attributes.s3Key}, date: formatDate(document.attributes.uploadedAt)}}
            canDelete={false}
            />
        ))}
        {this.props.userContext.hasScope(['fto', 'ftoc', 'sup', 'cstaff', 'chief'])
          ? <FileUploader
            onUpload={file => this.uploadDocument(file)}
            departmentGuid={this.props.userContext.departmentGuid}/>
          : null}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  userContext: state.common.userContext
});


export default withRouter(connect(mapStateToProps)(TrainingPhaseUploads));
